export function stripPhoneDigits(phone) {
	return (phone || '').replace(/\D/g, '').slice(0, 10)
}

/** Progressive (xxx) xxx-xxxx formatting while the user is typing. */
export function formatPhoneInput(phone) {
	const d = stripPhoneDigits(phone)
	if (!d) return ''
	if (d.length <= 3) return `(${d}`
	if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`
	return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`
}

export default (phone) => {
    if (!phone) return ''
    let formattedPhoneNumber = ''
    let number = stripPhoneDigits(phone).split('')
    if (number.length == 11) {
        formattedPhoneNumber += '+' + number[0] + ' '
        number.splice(0, 1)
    }
    for (let [index, digit] in number) {
        if (number.length >= 3) {
            if (index == 0) formattedPhoneNumber += '('
            if (index == 6) formattedPhoneNumber += '-'
            if (number[index]) formattedPhoneNumber += number[index]
            if (index == 2) formattedPhoneNumber += ') '
        }
    }
    return formattedPhoneNumber
}
